var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.9 104.6",
    style: {
      enableBackground: "new 0 0 80.9 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191B47;}\n\t.st1{fill:#255D9D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,56.9c-1.1-0.6-2.4-0.6-3.5,0l-9.8,5.7L17.4,69c0.3,0.5,0.7,1,1.3,1.3l7.8,4.5l0.3,0.2 c1.1,0.6,2.4,0.6,3.5,0l8.1-4.7c1.1-0.6,2.4-0.6,3.5,0l8.1,4.7c1.1,0.6,2.4,0.6,3.5,0l8.1-4.7c0.5-0.3,1-0.8,1.3-1.3l-11.1-6.4 L41.7,56.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,44.5c0-1.2-0.7-2.4-1.7-3L41.7,30.2c-1.1-0.6-2.4-0.6-3.5,0L18.7,41.5c-1.1,0.6-1.7,1.8-1.7,3v0 c0,0,0,0,0,0v22.7c0,0.6,0.2,1.2,0.5,1.7l11.1-6.4V51.2c0-1.2,0.7-2.4,1.7-3l8.1-4.7c1.1-0.6,2.4-0.6,3.5,0l8.1,4.7 c1.1,0.6,1.7,1.8,1.7,3v11.4L62.6,69c0.3-0.5,0.5-1.1,0.5-1.7V46.7v-0.3L63,44.5C63,44.5,63,44.5,63,44.5z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ba5bc8188d5e92d87986afa95f9cc382.svg";
export { ForwardRef as ReactComponent };